module.exports = __webpack_public_path__ + "static/media/signature-mouse.49113d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/signature-mouse.svg
// module id = 585
// module chunks = 9